import { P } from "theme/typography";
import { Box } from "@mui/material";
import { LensOutcomeStatusEditor } from "routes/lens-editor/settings/LensOutcomeStatusEditor";
import { LensInfoSection } from "routes/lens-editor/settings/LensInfoSection";

export const LensSettings = () => {
  return (
    <Box>
      <P variant="xlBold">Lens Info</P>
      <LensInfoSection />
      <P variant="xlBold">Lens Outcome Status</P>
      <LensOutcomeStatusEditor />
    </Box>
  );
};

export default LensSettings;
